import React, { useContext } from 'react'

import style from './QuickStartProgress.module.scss'
import { Link } from 'gatsby'

import MicrocopyContext from '~contexts/MicrocopyContext'

import { FiChevronLeft, FiChevronRight, FiChevronUp } from 'react-icons/fi'

const QuickStartProgress = ({
  page
}) => {
  const percentage = Math.floor(page.stepNumber / page.totalSteps * 100)
  const microcopy = useContext(MicrocopyContext)

  return (
    <div className={style.progress}>
        <header>
          <span>
            Step {page.stepNumber } of { page.totalSteps }
            <small>
              {percentage}%
            </small>
          </span>
          <div className={style.links}>
            <span>
              { page.previousPage && (
                <Link to={page.previousPage.path} title={ microcopy.text('guides.titles.previous', 'Next') }>
                  <FiChevronLeft />
                  <span>{ microcopy.text('guides.titles.previous', 'Previous') }</span>
                </Link>
              )}
            </span>
            <span>
              { page.parentPage && (
                <Link to={page.parentPage.path} title={ microcopy.text('guides.titles.start', 'Next') }>
                  <FiChevronUp />
                  <span>{ microcopy.text('guides.titles.start', 'Start') }</span>
                </Link>
              )}
            </span>
            <span>
              { page.nextPage && (
                <Link to={page.nextPage.path} title={ microcopy.text('guides.titles.next', 'Next') }>
                  <span>{ microcopy.text('guides.titles.next', 'Next') }</span>
                 <FiChevronRight />
                </Link>
              )}
            </span>
          </div>
        </header>

        <div className={style.progressBar}>
          <span style={{ width: `${percentage}%` }}></span>
        </div>        
    </div>
  )
}

export default QuickStartProgress